<div class="block">
  <div class="field is-grouped is-grouped-multiline">
    {#if tags.length > 0}
      {#each tags as tag, index}
        <div class="control">
          {#if tag.indexOf(':') > 0}
            <span class="tags has-addons">
              <span class="tag is-dark">{tag.split(':')[0]}</span>
              <span class="tag is-info">{tag.split(':')[1]}</span>
              {#if editTags}
                <!-- svelte-ignore a11y-missing-attribute -->
                <a
                  class="tag is-delete"
                  on:click={() => {
                    deleteAt(index);
                  }}>&nbsp</a>
              {/if}
            </span>
          {:else}
            <span class="tags has-addons">
              <span class="tag is-info">{tag}</span>
              {#if editTags}
                <!-- svelte-ignore a11y-missing-attribute -->
                <a
                  class="tag is-delete"
                  on:click={() => {
                    deleteAt(index);
                  }}>&nbsp</a>
              {/if}
            </span>
          {/if}
        </div>
      {/each}


      {#if !readonly}
      <!-- svelte-ignore a11y-missing-attribute -->
      <a
        class="icon has-text-grey-light"
        on:click={() => {
          editTags = !editTags;
          updateSavedTags();
        }}>
        <i class="mdi mdi-pencil" />
      </a>
      {/if}

    {:else}
      <div class="control">
        <span class="has-text-grey is-size-6">No tags</span>

        {#if !readonly}
        <!-- svelte-ignore a11y-missing-attribute -->
        <a
          class="icon has-text-grey-light"
          on:click={() => {
            editTags = !editTags;
            updateSavedTags();
          }}>
          <i class="mdi mdi-pencil" />
        </a>
        {/if}
      </div>
    {/if}
  </div>
</div>

{#if editTags}
  <div class="block">
    
      <div class="dropdown is-active">
        <div class="dropdown-trigger">
          <div class="field has-addons">
            <div class="control">
              <input
                on:focus={() => showSavedTags = true}
                on:blur={(event) => { if(!event.relatedTarget?.classList.contains('dropdown-item')) { showSavedTags = false }}}
                class="input is-small"
                type="text"
                placeholder="name or name:value"
                bind:value={newTag}
                size="30" />
            </div>
            <div class="control">
              <!-- svelte-ignore a11y-missing-attribute -->
              <button
                bind:this={addButtonEl}
                class="button is-info is-small"
                on:click={() => {
                  append();
                }}>
                Add
              </button>
            </div>
          </div>
        </div>
        {#if filteredDropdownItems.length > 0 && showSavedTags }
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="dropdown-content">
            {#each filteredDropdownItems as tag} 
            <a
            tabindex="-1"
            on:click={() => { newTag = tag; addButtonEl.focus(); showSavedTags = false; }} class="dropdown-item"> {tag}</a>
            {/each}
          </div>
        </div>
        {/if}
      </div>
      
    </div>
{/if}

<script type="ts">
  export let tags: string[], type: string, readonly: boolean;

  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  const typeCollection = {
    'company': 'companies_v1',
    'charity': 'charities_v2',
    'offer': 'offers_v2'
  }[type];

  let editTags = false;
  
  let showSavedTags = false;

  let addButtonEl : any;

  let newTag = '';

  let savedTags : string[] = [];
  let savedTagValues : string[] = [];
  
  $: dropdownItems = newTag.indexOf(':') === -1 ? savedTags : savedTagValues;

  $: filteredDropdownItems = 
  dropdownItems.filter(savedTag => 
    (savedTag.toLowerCase().indexOf(newTag.toLowerCase()) > -1) &&
    !tags.includes(savedTag)
  );

  $: {
    updateSavedTagValues(newTag);
  }

  function append() {
    addSavedTag(newTag);
    tags.push(newTag);
    tags = tags;
    newTag = '';
    dispatch('changed');

    updateSavedTags();
  }

  function deleteAt(index: number) {
    removeSavedTag(tags[index]);
    tags.splice(index, 1);
    tags = tags;
    dispatch('changed');

    updateSavedTags();
  }

  async function updateSavedTags() {
    savedTags = (await window.firebase.firestore().collection(`tags_v1/${type}/tags`).get()).docs.map(doc => doc.id);
    console.log(savedTags);
  }

  async function updateSavedTagValues(input: string) {
    if(input.indexOf(':') > -1) {
      const tag = newTag.split(':')[0];
      savedTagValues =  (await window.firebase.firestore().collection(`tags_v1/${type}/tags/${tag}:/values`).get()).docs.map(doc => tag + ':' + doc.id);
      console.log(savedTagValues);
    }
    else {
      savedTagValues = [];
    }
  }

  async function addSavedTag(tag: string) {

    const name = tag.split(':')[0];
    const value = tag.split(':')[1];

    window.firebase
      .firestore()
      .collection(`tags_v1/${type}/tags`)
      .doc(value ? name + ':' : name)
      .set({
        flag:true
      });

      if(value) {
        window.firebase
        .firestore()
        .collection(`tags_v1/${type}/tags/${name}/values`)
        .doc(value)
        .set({
          flag:true
        })
      }
  }

  async function removeSavedTag(tag: string) {

    const matches = await window.firebase
      .firestore()
      .collection(typeCollection!)
      .where('tags', 'array-contains', tag)
      .get();

    if(matches.empty) {
      const name = tag.split(':')[0];
      const value = tag.split(':')[1];

      if(value) {
        window.firebase
          .firestore()
          .collection(`tags_v1/${type}/tags/${name}/values`)
          .doc(value)
          .delete();
        
        const nameCollection = window.firebase
          .firestore()
          .collection(`tags_v1/${type}/tags/${name}/values`)
          .get();

        if((await nameCollection).empty) {
          window.firebase
          .firestore()
          .collection(`tags_v1/${type}/tags`)
          .doc(name)
          .delete();
        }
      }
      else {
        window.firebase
        .firestore()
        .collection(`tags_v1/${type}/tags`)
        .doc(name)
        .delete()
      }

    }
  }
</script>
